// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"3e2bc974","115":"766e5cb8","239":"ea02c734","375":"4a4ac74b","388":"145c03d0","457":"d9698ace","498":"4d6b271d","551":"720ddb8e","631":"fbedac78","640":"cbf14262","732":"1d248ce8","851":"e8f3dd34","977":"b4b6265e"}[chunkId] + ".chunk.js";
};